import { replacePropsWithPreview } from '../../utils';

type LocationMapProps = {
    adId: number;
    location?: { address?: string; locality?: string; latitude?: number; longitude?: number };
    isPreview: boolean;
};

export const LocationMap = ({ adId, location, isPreview }: LocationMapProps) => {
    const latlng = `lat=${location?.latitude ?? 0}&lng=${location?.longitude ?? 0}`;
    let locationText = location?.address || location?.locality;

    // TODO REIS-4591 Switch to only location.address when we switch to fasaden
    if (location?.address && location.locality && !location.address?.includes(location?.locality)) {
        locationText += `, ${location.locality}`;
    }

    return (
        <>
            <div className="mb-16" data-testid="locationText">{`${locationText}`}</div>
            <div className="img-format block" data-testid="adLocation">
                <a
                    {...replacePropsWithPreview(
                        {
                            href: `https://kart.finn.no/?finnkode=${adId}&${latlng}&mapType=finnvector&showPin=1&bl=1`,
                            rel: 'external',
                        },
                        isPreview
                    )}>
                    <img
                        src={`https://maptiles.finncdn.no/staticmap?${latlng}&zoom=14&size=620x400&maptype=norwayVector&showPin=true`}
                        alt="Kart"
                        className="img-format__img rounded-8"
                        sizes="(min-width: 1000px)"
                    />
                </a>
            </div>
        </>
    );
};
